import 'bootstrap/dist/css/bootstrap.css';
import React,{Component} from "react";
import FeatFound from "./FeatFound";
import SpotifyWebApi from 'spotify-web-api-js';
import SearchInput from './SearchInput';
import axios from 'axios';
import Notfound from './NotFound';
import Footer from './Footer';
import './styles.css'


class FindButton extends Component {

  state = {loaded: false,
            found: []}

 /* finder = (list1, list2) => {
    const mapList1 = list1.reduce((acc, item) => {
      acc[item.id] = item;
      //console.log(item.id)
      return acc;
    }, {});
    
    const mapList2 = list2.reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {});
    
    // Creiamo una terza lista con gli oggetti che hanno lo stesso id in entrambe le liste
    const resultList = Object.keys(mapList1).reduce((acc, key) => {
      if (mapList2[key]) {
        acc.push(mapList1[key]);
      }
      return acc;
    }, []);
    
    console.log(resultList);


    this.setState({loaded: true,
                  found: resultList})
  }*/

  finderAdvaced = (list1, list2) => {

    const spotify = new SpotifyWebApi();
    var resultAdv = [];
    if(spotify.getAccessToken() == null){
      const authOptions = {
        url: 'https://accounts.spotify.com/api/token',
        headers: {
          Authorization: `Basic ${btoa(SearchInput.CLIENT_ID + ':' + SearchInput.CLIENT_SECRET)}`,
        },
        data: 'grant_type=client_credentials',
      };
  
      axios
        .post(authOptions.url, authOptions.data, { headers: authOptions.headers })
        .then((response) => {
          const token = response.data.access_token;
          //const spotify = new SpotifyWebApi();
          spotify.setAccessToken(token);
          console.log("got token from finder")
        })
        .catch((error) => {
          console.error(error);
        });
    } else {

      var id1 = this.props.idSx
      var id2 = this.props.idDx
      var matchIDS = [id1, id2]
      const encounteredIds = new Set();
      const encounteredNames = new Set();

      //console.log(id1,id2)
      list1.forEach((code, index) => {
        //console.log(code.name); 
        spotify.getAlbumTracks(code.id, {limit: 50})
        .then((album) =>{
            //console.log(album.name)
            album.items.forEach((track) => {
             // console.log(track.name, track.artists);
              if(matchIDS.every((targetID) => track.artists.some((artist) => artist.id === targetID))){
                if(!encounteredIds.has(track.id)){
                  if(!encounteredNames.has(track.name)){
                    track["img"] = code.images[0].url
                    resultAdv.push(track)
                   // console.log("immagine", code.images[0])
                    encounteredNames.add(track.name)
                  }
                  encounteredIds.add(track.id)
                  console.log(track)
                }
                  
              }
            });
        })
        .catch((err) => {
          if(err.status == 429){
            list1.length = index+1
            alert("Server overload, sorry for the inconvenience")
          }
        });
      });

      /*setTimeout(function() {
        //console.log("This message appears after a 2-second delay.");
      }, 1000);*/

      list2.forEach((code, index) => {
        //console.log(album.id); 
        spotify.getAlbumTracks(code.id, {limit: 50})
        .then((album) =>{
            //console.log(album.name)
            album.items.forEach((track) => {
              //console.log(track.artists);
              if(matchIDS.every((targetID) => track.artists.some((artist) => artist.id === targetID))){
                if(!encounteredIds.has(track.id)){
                  if(!encounteredNames.has(track.name)){
                    track["img"] = code.images[0].url
                    resultAdv.push(track)
                    //console.log("immagine", code.images[0])
                    encounteredNames.add(track.name)
                  }
                  encounteredIds.add(track.id)
                  console.log(track)
                }
              }
            });
        })
        .catch((err) => {
          if(err.status == 429){
            list2.length = index+1
            alert("Server overload, sorry for the inconvenience")
          }
        });
      });

    }
    
    console.log(resultAdv)

    setTimeout(() => {
      this.setState({
        loaded: true,
        found: resultAdv,
      });
    }, 1000);
    
   


      

  }


  componentDidUpdate(prevProps){
    if(this.props.idSx !== prevProps.idSx || this.props.idDx !== prevProps.idDx){
      this.setState({loaded: false})
      this.props.onFooter();
    }
  }
  handleFooterPosition = (fixed) => {
    this.props.onFinalFooterSet();
  };


render(){
  return(
    <div>
<div class="container">
    <div class="row">
     
      <div class="col">
      <input type="submit" value="FIND!" class="btn" onClick={() => { this.finderAdvaced(this.props.tracksSx, this.props.tracksDx)}} style={{ background: '#D9E724', borderColor: '#8b008b', color:'black', fontWeight: "bold"}}/>
      </div>
    
    </div>
    <div class="row">
      <div class="col">{this.state.loaded === true ? (
  (this.props.idSx !== "" && this.props.idDx !== "") ? (
    this.state.found.length > 0 ? (
      <FeatFound found={this.state.found} onFooterPosition={this.handleFooterPosition}/>
    ) : (
      <Notfound />
    )
  ) : (
    <div>
      {this.props.idSx === "" && <h1 style={{marginTop: '30px'}}>The left artist is missing!</h1>}
      {this.props.idDx === "" && <h1 style={{marginTop: '30px'}}>The right artist is missing!</h1>}
    </div>
  )
) : (
  ""
)}

</div>

    </div>
    </div>
    </div>
    
  )
}
  
}

export default FindButton;